import { render } from "./Checkbox.vue?vue&type=template&id=40df19c0&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=40df19c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40df19c0"]])

export default __exports__